import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getWidgetElementImmutable, isInlineScpEditable as getIsInlineScpEditable
// @ts-ignore not typed
} from 'InpageEditorUI/lib/inpage/utils';

// Need custom hashing function to memoize more than one argument. And even though
// `buildActionsFor*` may take more than N arguments, only the first N matter for
// memoization (the dispatch function and bus will always been the same)

export const hashFunctionForNArgs = n => {
  return (...args) => args.slice(0, n).join('-');
};
export const hashFunctionForObject = object => {
  return Object.keys(object).reduce((acc, key) => acc + key + object[key], '');
};
export const getResponsiveToolbarPinLocation = (top, toolbarHeight, isSelectedItem) => {
  if (top && toolbarHeight && top - toolbarHeight < 0) {
    return 'top right';
  }
  return isSelectedItem ? 'bottom right' : 'top right';
};
export const getShouldNotOpenSidebarOnEditClick = (state, module) => {
  const isDataAuthoringModeActive = getIsDataAuthoringModeActive(state);
  let isInlineScpEditable = false;
  if (isDataAuthoringModeActive) {
    const {
      $widget
    } = getWidgetElementImmutable(module);
    isInlineScpEditable = getIsInlineScpEditable(module, $widget);
  }
  return isInlineScpEditable;
};